import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Item, MenuTrigger, ActionButton, Menu } from '@adobe/react-spectrum';

import Icon from '../../../../../components/Icon';
import { getParams } from './utils';
import { getRandomColor } from '../../../utils';
import {
  Overdue,
  Wrap,
  TaskCard,
  TaskColor,
  CardContent,
  CardContentMiddle,
  ProjectName,
  DueDate,
  Circle,
  CardContentRight,
  Actions,
  Status,
  StatusText,
} from './styles';

const { getStatusColorAndLabel } = require('../../../../../utils/utils');

const Cards = ({ headers, projects, viewBy }) => {
  const handleRedirect = (url, projectId) => {
    const redirectTo = `${url}/project/${projectId}/tasks`;
    window.open(redirectTo, '_blank');
  };

  const getProjectStatusTextAndColor = date => {
    const taskEndDate = new Date(date.slice(0, 16));
    const today = new Date();
    const difference = moment(taskEndDate).diff(today, 'days');
    if (difference < 0)
      return {
        color: 'e34850',
        daysLeft: <Overdue>Overdue</Overdue>,
      };
    if (difference <= 1)
      return { color: 'f2942e', daysLeft: `${difference} Day until due` };
    return { color: '268e6c', daysLeft: `${difference} Days until due` };
  };

  return (
    <Wrap>
      {headers.length > 0 &&
        projects.map(project => {
          const params = getParams(project, headers, viewBy);
          const { project: thisProject } = project;

          return (
            params && (
              <TaskCard
                key={thisProject.ID}
                cardId={thisProject.ID}
                left={params.marginLeft}
                right={params.marginRight}
                display={params.display}
              >
                <TaskColor color={getRandomColor()} />
                <CardContent>
                  <CardContentMiddle>
                    <ProjectName>Project: {thisProject.name}</ProjectName>
                    <DueDate>
                      <Circle
                        color={
                          getProjectStatusTextAndColor(
                            thisProject.plannedCompletionDate,
                          ).color
                        }
                      />
                      <span>
                        {
                          getProjectStatusTextAndColor(
                            thisProject.plannedCompletionDate,
                          ).daysLeft
                        }
                      </span>
                    </DueDate>
                  </CardContentMiddle>
                  <CardContentRight>
                    <Actions>
                      <MenuTrigger>
                        <ActionButton UNSAFE_className="action-button">
                          <Icon name="..." />
                        </ActionButton>
                        <Menu
                          onAction={() =>
                            handleRedirect(
                              project.workfrontEndpoint,
                              thisProject.ID,
                            )
                          }
                        >
                          <Item key="workfront">Workfront link</Item>
                        </Menu>
                      </MenuTrigger>
                    </Actions>
                    {project.status ? (
                      <Status>
                        <i>Status</i>
                        <StatusText>
                          {
                            getStatusColorAndLabel(
                              project.status,
                              project.allStatuses,
                            )[1]
                          }
                        </StatusText>
                      </Status>
                    ) : (
                      <Status />
                    )}
                  </CardContentRight>
                </CardContent>
              </TaskCard>
            )
          );
        })}
    </Wrap>
  );
};

Cards.propTypes = {
  viewBy: PropTypes.number,
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.instanceOf(Date).isRequired,
      format: PropTypes.string,
      id: PropTypes.number,
    }),
  ).isRequired,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.string,
      name: PropTypes.string,
      objCode: PropTypes.string,
      percentComplete: PropTypes.number,
      plannedCompletionDate: PropTypes.string,
      plannedStartDate: PropTypes.string,
      progressStatus: PropTypes.string,
      project: PropTypes.shape({
        ID: PropTypes.string,
        name: PropTypes.string,
        objCode: PropTypes.string,
        percentComplete: PropTypes.number,
        plannedCompletionDate: PropTypes.string,
        plannedStartDate: PropTypes.string,
      }),
    }),
  ).isRequired,
};

Cards.defaultProps = {
  viewBy: null,
};

export default Cards;
